<template>
    <b-modal id='sign-in' hide-footer> 
        <template v-slot:modal-title>
            <b-img src="./dist/logo-esp.svg" fluid></b-img>
        </template>

        <b-card >
            <template v-slot:header>
                <h3 class='introduce'>Добро пожаловать! 
                    <span :style="{
                        'color': '#ff0000c9',
                        'margin-left': 'auto'
                    }"><font-awesome-icon :icon="['fas', 'virus-slash']"/></span>
                </h3>
            </template>
            <b-form class='login-form' @submit.prevent='tryToSignIn'>
                <b-form-group label='Логин'>
                    <b-input-group>
                        <b-form-input type="text"  placeholder="Логин"  v-model='login' />
                    </b-input-group>
                    <b-form-invalid-feedback :state="validLogin">
                        <em>Ваш логин должен быть длиннее 3 символов</em>
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label='Пароль'>
                    <b-form-input type="password" placeholder="Пароль" v-model='password' />
                    <b-form-invalid-feedback :state="validPassword">
                        <em>Ваш пароль должен быть длиннее 3 символов</em>
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group>
                    <b-button 
                        variant="outline-dark" 
                        class='login-form__submit float-right'
                        type='submit'
                    >   
                        <span v-if='!processing'>Вход <font-awesome-icon :icon="['fas', 'sign-in-alt']"/></span>
                        <b-spinner v-else small type="grow"></b-spinner>
                    </b-button>
                </b-form-group> 
            </b-form>
        </b-card>


        <b-toast id="wrong-pair" variant="danger" solid no-auto-hide>
            <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline text-center">
                <b-img blank blank-color="#ff5555" class="mr-2" width="12" height="12"></b-img>
                <strong class="mr-auto">Логин или Пароль неверны</strong>
            </div>
            <em>Внимательно введите данные снова. 
            <br>При повторных ошибках, обратитесь в IT отдел за консультацией.</em>
        </b-toast>   

        <b-toast id="red-alert" variant="danger" solid no-auto-hide>
            <div slot="toast-title" class="d-flex flex-grow-1 align-items-baseline text-center">
                <b-img blank blank-color="#ff5555" class="mr-2" width="12" height="12"></b-img>
                <strong class="mr-auto">Красная тревога</strong>
            </div>
            <em>Без паники, товарищи!
                <br>Но что-то пошло сильно не по плану.
                <br>IT отдел делает все возможное для решения проблемы.
                <br>Спасибо за понимание!
            </em>
        </b-toast>   
    </b-modal>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'


export default {
    name: 'sign-in',
    methods: {
        tryToSignIn() {
            if (this.validLogin && this.validPassword) {
                this.signIn().then(() => {
                    if (!this.userData.id_login) {
                        this.$bvToast.show('wrong-pair')
                    } else this.$bvModal.hide('sign-in')
                })
            }
        },

        ...mapActions('login', [
            'signIn', 'updateLogin', 'updatePassword'
        ])
    },
    computed: {
        login: {
            get() { 
                if (this.form.login == '') {
                    this.updatePassword('')
                }
                return this.form.login 
            },
            set(value) { this.updateLogin(value) }
        },
        password: {
            get() { return this.form.password },
            set(value) { this.updatePassword(value) }
        },
        validLogin() {
            return this.login.length > 3
        },
        validPassword() {
            return this.password.length > 3
        },
        ...mapState({
            form: state => state.login.form,
            userData: state => state.userData,
            processing: state => state.processing
        })
    },
    watch: {
        userData(userData) {
            if (!userData) {
                this.$bvToast.show('red-alert')
            }
        }
    }

}
</script>

<style scoped>
.login-form__submit {
    width: 100px;
}
/* .jumbotron { 
    background-image: url(../assets/bg-jumbo.jpg);
    background-size: cover;
    background-repeat: no-repeat;
} */
.introduce {
    display: inline-flex;
    width: 100%;
}
.introduce--icon {
    margin-left: auto;
    margin-top: auto;
}


@media (max-width: 576px) {
    .introduce {
        font-size: 1.2rem;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/SignIn.vue